module.exports = __webpack_public_path__ + "static/media/halifaxlogo.d95dc723.png";